import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, Paper, Stack, Typography } from "@mui/material";
import { memo } from "react";
import SuperfluidLogo from "./SuperfluidLogo.js";
const PoweredBySuperfluid = ({ sx = {} }) => (_jsx(Paper, { "data-testid": "powered-by-superfluid", component: Link, variant: "outlined", href: "https://superfluid.finance", target: "_blank", sx: {
        px: 4,
        py: 1.5,
        borderRadius: 0.5,
        textDecoration: "none",
        ...sx,
    }, children: _jsxs(Stack, { direction: "row", spacing: 1, alignItems: "center", children: [_jsx(Typography, { variant: "body2", color: "text.secondary", children: "Powered by" }), _jsx(SuperfluidLogo, {})] }) }));
export default memo(PoweredBySuperfluid);
